import { inject, injectable } from "tsyringe";
import { WINDOW } from "../symbols";

@injectable()
export class AdsContext {
  constructor(@inject(WINDOW) private readonly window: Window) {}

  get() {
    return this.window.ads?.context;
  }
}
